<script setup lang='ts'>
import ApplyToEnd from './ApplyToEnd.vue'

const _props = withDefaults(defineProps<{
  portalUserId?: number
  carBrandId?: number
  carSeriesId?: number
  isSurveyBottom?: boolean
}>(), {
  portalUserId: 0,
  carBrandId: 0,
  carSeriesId: 0,
  isSurveyBottom: false,
})

const { getUserInfoItem } = useAuth()
</script>

<template>
  <div class="fixed text-5">
    <NAffix :top="450">
      <div v-if="getUserInfoItem('id') !== portalUserId" class="fixed-container flex items-center justify-center">
        <NuxtLink target="_blank" :to="`/publish?brandId=${carBrandId}&seriesId=${carSeriesId}`">
          我也要投诉
        </NuxtLink>
      </div>
      <ApplyToEnd v-if="getUserInfoItem('id') === portalUserId && !isSurveyBottom">
        <div class="fixed-container flex items-center justify-center">
          申请一追到底
        </div>
      </ApplyToEnd>
    </NAffix>
  </div>
</template>

<style lang='scss' scoped>
.fixed {
  position: absolute;
  top: 0;
  left: -70px;

  &-container {
    width: 60px;
    padding: 16px 0;
    min-height: 200px;
    background: theme('colors.blue.500');
    border-radius: 6px;
    overflow: hidden;
    font-size: 28px;
    color: #fff;
    writing-mode: vertical-lr;
    letter-spacing: 6px;
    cursor: pointer;
  }
}
</style>
